/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

/**
 * Don't edit this file. Instead, create a new page in "src/pages"
 * and a new route will be created for you the next time you build
 * the project.
 *
 * Generated by "src/tools/createPageRoutes.ts"
 */

import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import AsyncPageRoute from "~/components/AsyncPageRoute";

const PageIndex = lazy(() => import("~/pages"));
const PageApp = lazy(() => import("~/pages/app"));
const PageAppWhite_label = lazy(() => import("~/pages/app/white-label"));
const PageAppTwofactorauth = lazy(() => import("~/pages/app/twofactorauth"));
const PageAppTos = lazy(() => import("~/pages/app/tos"));
const PageAppStatistics = lazy(() => import("~/pages/app/statistics"));
const PageAppSignup = lazy(() => import("~/pages/app/signup"));
const PageAppSetpassword = lazy(() => import("~/pages/app/setpassword"));
const PageAppReset_password = lazy(() => import("~/pages/app/reset-password"));
const PageAppPromo_tools = lazy(() => import("~/pages/app/promo-tools"));
const PageAppPrivacy_policy = lazy(() => import("~/pages/app/privacy-policy"));
const PageAppLogout = lazy(() => import("~/pages/app/logout"));
const PageAppLogin = lazy(() => import("~/pages/app/login"));
const PageAppForgot_password = lazy(() => import("~/pages/app/forgot-password"));
const PageAppForced_password_reset = lazy(() => import("~/pages/app/forced-password-reset"));
const PageAppDashboard = lazy(() => import("~/pages/app/dashboard"));
const PageAppCompliance = lazy(() => import("~/pages/app/compliance"));
const PageAppSupportFaq = lazy(() => import("~/pages/app/support/faq"));
const PageAppSupportContact = lazy(() => import("~/pages/app/support/contact"));
const PageAppSupportApi = lazy(() => import("~/pages/app/support/api"));
const PageAppSignupVerify = lazy(() => import("~/pages/app/signup/verify"));
const PageAppSignupResendverify = lazy(() => import("~/pages/app/signup/resendverify"));
const PageAppOne_clickEncoding = lazy(() => import("~/pages/app/one-click/encoding"));
const PageAppOne_clickDecoding = lazy(() => import("~/pages/app/one-click/decoding"));
const PageAppMy_sitesPostbacks = lazy(() => import("~/pages/app/my-sites/postbacks"));
const PageAppMy_sitesManage_sites = lazy(() => import("~/pages/app/my-sites/manage-sites"));
const PageAppMy_sitesCreate_new_site = lazy(() => import("~/pages/app/my-sites/create-new-site"));
const PageAppMy_sitesPostbacksEdit = lazy(() => import("~/pages/app/my-sites/postbacks/edit"));
const PageAppMy_sitesPostbacksAdd = lazy(() => import("~/pages/app/my-sites/postbacks/add"));
const PageAppMy_sitesCreate_new_siteWhite_label = lazy(() => import("~/pages/app/my-sites/create-new-site/white-label"));
const PageAppMy_sitesCreate_new_sitePromote_site = lazy(() => import("~/pages/app/my-sites/create-new-site/promote-site"));
const PageAppMy_sitesCreate_new_siteBlack_label = lazy(() => import("~/pages/app/my-sites/create-new-site/black-label"));
const PageAppMy_accountPayout_info = lazy(() => import("~/pages/app/my-account/payout-info"));
const PageAppMy_accountMy_details = lazy(() => import("~/pages/app/my-account/my-details"));
const PageAppMy_accountEmail_preferences = lazy(() => import("~/pages/app/my-account/email-preferences"));
const PageAppMy_accountDocuments = lazy(() => import("~/pages/app/my-account/documents"));
const PageAppLearn_moreWebcams = lazy(() => import("~/pages/app/learn-more/webcams"));
const PageAppLearn_moreProduct = lazy(() => import("~/pages/app/learn-more/product"));
const PageAppLearn_moreNetwork = lazy(() => import("~/pages/app/learn-more/network"));
const PageAppLearn_moreCustomizations = lazy(() => import("~/pages/app/learn-more/customizations"));
const PageAppLearn_moreAffiliates = lazy(() => import("~/pages/app/learn-more/affiliates"));

const pageRoutes: RouteObject[] = [
  {
    index: true,
    element: (
      <AsyncPageRoute>
        <PageIndex />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app",
    element: (
      <AsyncPageRoute>
        <PageApp />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/white-label",
    element: (
      <AsyncPageRoute>
        <PageAppWhite_label />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/twofactorauth",
    element: (
      <AsyncPageRoute>
        <PageAppTwofactorauth />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/tos",
    element: (
      <AsyncPageRoute>
        <PageAppTos />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/statistics",
    element: (
      <AsyncPageRoute>
        <PageAppStatistics />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/signup",
    element: (
      <AsyncPageRoute>
        <PageAppSignup />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/setpassword",
    element: (
      <AsyncPageRoute>
        <PageAppSetpassword />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/reset-password",
    element: (
      <AsyncPageRoute>
        <PageAppReset_password />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/promo-tools",
    element: (
      <AsyncPageRoute>
        <PageAppPromo_tools />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/privacy-policy",
    element: (
      <AsyncPageRoute>
        <PageAppPrivacy_policy />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/logout",
    element: (
      <AsyncPageRoute>
        <PageAppLogout />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/login",
    element: (
      <AsyncPageRoute>
        <PageAppLogin />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/forgot-password",
    element: (
      <AsyncPageRoute>
        <PageAppForgot_password />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/forced-password-reset",
    element: (
      <AsyncPageRoute>
        <PageAppForced_password_reset />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/dashboard",
    element: (
      <AsyncPageRoute>
        <PageAppDashboard />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/compliance",
    element: (
      <AsyncPageRoute>
        <PageAppCompliance />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/support/faq",
    element: (
      <AsyncPageRoute>
        <PageAppSupportFaq />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/support/contact",
    element: (
      <AsyncPageRoute>
        <PageAppSupportContact />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/support/api",
    element: (
      <AsyncPageRoute>
        <PageAppSupportApi />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/signup/verify",
    element: (
      <AsyncPageRoute>
        <PageAppSignupVerify />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/signup/resendverify",
    element: (
      <AsyncPageRoute>
        <PageAppSignupResendverify />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/one-click/encoding",
    element: (
      <AsyncPageRoute>
        <PageAppOne_clickEncoding />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/one-click/decoding",
    element: (
      <AsyncPageRoute>
        <PageAppOne_clickDecoding />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/my-sites/postbacks",
    element: (
      <AsyncPageRoute>
        <PageAppMy_sitesPostbacks />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/my-sites/manage-sites",
    element: (
      <AsyncPageRoute>
        <PageAppMy_sitesManage_sites />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/my-sites/create-new-site",
    element: (
      <AsyncPageRoute>
        <PageAppMy_sitesCreate_new_site />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/my-sites/postbacks/edit",
    element: (
      <AsyncPageRoute>
        <PageAppMy_sitesPostbacksEdit />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/my-sites/postbacks/add",
    element: (
      <AsyncPageRoute>
        <PageAppMy_sitesPostbacksAdd />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/my-sites/create-new-site/white-label",
    element: (
      <AsyncPageRoute>
        <PageAppMy_sitesCreate_new_siteWhite_label />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/my-sites/create-new-site/promote-site",
    element: (
      <AsyncPageRoute>
        <PageAppMy_sitesCreate_new_sitePromote_site />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/my-sites/create-new-site/black-label",
    element: (
      <AsyncPageRoute>
        <PageAppMy_sitesCreate_new_siteBlack_label />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/my-account/payout-info",
    element: (
      <AsyncPageRoute>
        <PageAppMy_accountPayout_info />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/my-account/my-details",
    element: (
      <AsyncPageRoute>
        <PageAppMy_accountMy_details />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/my-account/email-preferences",
    element: (
      <AsyncPageRoute>
        <PageAppMy_accountEmail_preferences />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/my-account/documents",
    element: (
      <AsyncPageRoute>
        <PageAppMy_accountDocuments />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/learn-more/webcams",
    element: (
      <AsyncPageRoute>
        <PageAppLearn_moreWebcams />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/learn-more/product",
    element: (
      <AsyncPageRoute>
        <PageAppLearn_moreProduct />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/learn-more/network",
    element: (
      <AsyncPageRoute>
        <PageAppLearn_moreNetwork />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/learn-more/customizations",
    element: (
      <AsyncPageRoute>
        <PageAppLearn_moreCustomizations />
      </AsyncPageRoute>
    ),
  },
  {
    path: "app/learn-more/affiliates",
    element: (
      <AsyncPageRoute>
        <PageAppLearn_moreAffiliates />
      </AsyncPageRoute>
    ),
  },
];

export default pageRoutes;
